import ErrorMessage from './ErrorMessage.component';

export default ErrorMessage;
